export const MAX_VISIBLE_OPTIONS_COUNT = 5;

export const MENU_MARGIN = 4;
